import {useMemo} from 'react';
import {useSelector} from 'react-redux';
import {useGetSignatureBasesQuery} from '../store/builder/inspections.api';

// `external_code` belongs to the SFS revision only, so the field is hidden -
// and left out of the payload - unless the user's agency is on it.
const EXTERNAL_CODE_REVISION = 'SFS/02/2023';

export function useIsExternalCodeRevision() {
  return useSelector(
    state =>
      state?.rootReducer?.loginSlice?.user?.agency?.inspections_revision ===
      EXTERNAL_CODE_REVISION,
  );
}

// The options of a facility's `external_code` live on the signature api, which
// returns ready made `{label, value}` pairs.
export function useSignatureBaseOptions({skip = false} = {}) {
  const {data, isFetching} = useGetSignatureBasesQuery(undefined, {skip});
  const options = useMemo(() => {
    const list = Array.isArray(data) ? data : (data?.data ?? []);
    return list
      .map(entry =>
        entry !== null && typeof entry === 'object'
          ? {label: entry?.label, value: entry?.value}
          : {label: entry, value: entry},
      )
      .filter(
        option =>
          option.value !== null &&
          option.value !== undefined &&
          option.value !== '',
      )
      .map(option => ({
        label: String(option.label ?? option.value),
        value: String(option.value),
      }));
  }, [data]);
  return [options, isFetching];
}
